import Repository from './Repository';

const USER = '/user';

export default {
	getCurrentUser(obj) {
		return Repository.get(`${USER}`, obj);
	},
};
